import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // import AOS styles
import Achievements from "./Achievment";
import Team from "./Team";
import "./Teacher.css";
import sir from "../images/sir4.webp";
import MapComponent from "../components/Map";
// import CalendarComponent from "../components/CalendarComponent";
const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // duration of animations in ms
      easing: "ease-in-out", // easing function
    });
  }, []);

  return (
    <>
      <section className="about__teacher">
        <div className="container about__teacher-container">
          <div className="about__teacher-left" data-aos="fade-up">
            <h1>Our Teacher</h1>
            <p>
              Mr. Chetan sir is the driving force behind JEE Vision Coaching.
              With 10+ years of experience in teaching mathematics, he brings
              unparalleled expertise and passion to the classroom. His unique
              teaching methods simplify complex concepts, making them accessible
              and engaging for all students. Mr. Chetan sir is dedicated to
              helping each student reach their full potential, providing
              personalized guidance and support throughout their learning
              journey. His commitment to excellence and student success sets JEE
              Vision Coaching apart.
            </p>
          </div>
          <div className="about__teacher-right" data-aos="fade-left">
            <img src={sir} alt="sir" />
            <h3>Chetan Sir</h3>
          </div>
        </div>
      </section>
      <Achievements />
      <MapComponent />
      {/* <CalendarComponent /> */}
      <Team />
    </>
  );
};

export default About;
